// @vendors
import { useContext, useEffect, useState } from "react";
import { Button, Divider, Tooltip } from "antd";
import Colision from "../../../assets/images/colision.png";
import Check from "../../../assets/images/check-circle-c2.svg";
// @styles
import "./styles.scss";
import Pdf from "components/pdf";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import Context from "context/appContext";
import { coveragesSelected, getBodyCoverage, getUrl } from "utils/utils";
import Modalities from "components/modalities";
import Loading from "components/loading";
import AlertInfo from "components/alert-info";

export default function Plans({ info, key, form, current }) {
  const [showDetail, setShowDetail] = useState(false);
  const [modalitie, setModalitie] = useState([]);
  const [coverages, setCoverages] = useState([]);
  const [message, setMessage] = useState();
  const [image, setImage] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [imageColision, setImageColision] = useState("");
  const [loading, setLoading] = useState(true);
  const [coveragesAdditionals, setCoveragesAdditionals] = useState([]);
  const [mandatories, setMandatories] = useState([]);
  const [mandatoriesAdditionals, setMandatoriesAdditionals] = useState([]);
  const [showCompare, setShowCompare] = useState(false);
  const {
    formStatus: {
      steps,
      currentStep,
      currentQuestion,
      numberQuestionsStep,
      isGoToBack,
    },
    customRequest,
    dataForm: { data, formResponses },
    model,
    executeCoverage,
    setFormStatus,
    folio,
    tokenInfo,
    setExecuteCoverage,
    setCoverageAdd,
    setModalities,
    setSidebarData,
    setPriceToShow,
    setIsSideBarUpdate,
    setTotalCoverages,
    setModality,
    setCleanAditionalCoverages
  } = useContext(Context);

  const next = (coverageModalitie) => {
    const currentQuestionValue = 0;   
    const currentStepValue = currentStep + 1;
    const index = formResponses.findIndex((x) => x.key === info.key);
    const coveragesSelecteded = coveragesSelected(coverageModalitie, coverages);
    index != -1
      ? (formResponses[index] = {
        key: "coberturas",
        ...info,
        coverages: coveragesSelecteded,
        coveragesAdd: coveragesAdditionals,
        modalities: modalitie,
        ...coverageModalitie,
      })
      : formResponses.push({
        key: "coberturas",
        ...info,
        coverages: coveragesSelecteded,
        coveragesAdd: coveragesAdditionals,
        modalities: modalitie,
        ...coverageModalitie,
      });

    setCoverageAdd(coveragesAdditionals);
    setTotalCoverages(coverages);
    setModalities(modalitie);
    setModalitie(coverageModalitie);
    setModality();
    setCleanAditionalCoverages(true);
    setFormStatus({
      steps,
      currentStep: currentStepValue,
      currentQuestion: currentQuestionValue,
      numberQuestionsStep: steps[currentStepValue]?.questions.length,
      isGoToBack,
    });      
     
     window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
     window.dataLayer.push({
      event: "select_item",
      ecommerce: {
      item_list_id: "related_products",
      item_list_name: "Movilidad",
      items: [
    {
        item_id: "Movilidad", // Incluir SKU que indique el sistema
        item_name: "Seguro de movilidad total",
        affiliation: "", // y SURA Agente cuando es B2B
        item_brand: "SURA",
        item_category:"Movilidad",
        location_id: "ChIJIQBpAG2ahYAR_61",
        price:"",
        quantity: 1
    }
      ]
     }
   });  

    window.dataLayer.push({
      'event' : 'mov_05_plan',
      'plan' : coverageModalitie.modality
    })
  };

  useEffect(() => {
    getValues();
  }, []);

  const recorredPropertie = (coverages) => {
    let copyCoverage = [];
    let additionals = [];
    if (coverages && coverages.length) {
      coverages.forEach((coverage) => {
        if (coverage.modalities && coverage.modalities.length) {
          let obj = {};
          coverage.modalities.forEach((m) => (obj[m.modalityId] = m));
          coverage.modalities = obj;
        }
        if (coverage.optional) {
          additionals.push(coverage);
        }
        copyCoverage.push(coverage);
      });
    }
    if (additionals.length > 0) {
      setCoveragesAdditionals(additionals);
    }
    return copyCoverage;
  };

  const buildCoverages = (coverages, mandatories, additionals) => {
    let copyCoverage = recorredPropertie(coverages);
    let copyMandatories = recorredPropertie(mandatories);
    let copyAdditionals = recorredPropertie(additionals);
    setMandatories(copyMandatories);
    setCoverages(copyCoverage);
    setMandatoriesAdditionals(copyAdditionals);
  };

  const getCoverage = async (info) => {
    setLoading(true);
    const opciones_servicio = getUrl(info.content, formResponses);
    const bodyCoverage = getBodyCoverage(formResponses, folio, tokenInfo);
    const response = await customRequest(
      opciones_servicio.url,
      opciones_servicio.headers,
      opciones_servicio.method,
      bodyCoverage
    );
    if (response && response.data) {
      setExecuteCoverage(response);
    }
    return response;
  };

  const getValues = async () => {
    if (info && info.content) {
      setPriceToShow("");
      setCoverageAdd([]);
      setModality("");
      setIsSideBarUpdate(false);
      const response = executeCoverage
        ? executeCoverage
        : await getCoverage(info);

      const valuesResponse =
        response && response.length
          ? response
          : response && response.data
            ? response.data
            : [];

      if (
        valuesResponse &&
        valuesResponse.modalities &&
        valuesResponse.coverages &&
        valuesResponse.sections &&
        valuesResponse.sections.mandatories.length
      ) {
        buildCoverages(
          valuesResponse.coverages,
          valuesResponse.sections.mandatories,
          valuesResponse.sections.aditionals
        );
        getRecomended(valuesResponse.modalities);
        setSidebarData([]);
      }
    }
    if (current && current.primary) {
      setImage(current.primary.opciones_servicio);
    }
    setSubTitle(current?.primary?.collapsable_text[0]?.text);
    getMessageColision();
    setLoading(false);
  };

  const getMessageColision = () => {
    let messages = [];
    const versionVehicle = formResponses.find(
      (e) => e.key === "versionVehiculo"
    );
    if (versionVehicle && versionVehicle.value.cw) {
      messages = [
        {
          title: "",
          description: info.properties["CW"],
        },
      ];
    }
    setMessage(messages);
    setImageColision(Colision);
  };

  const getRecomended = (modalities) => {
    const moonLanding = new Date();
    const currentYear = moonLanding.getFullYear();
    const yearsAntique = currentYear - model;
    if (info.properties) {
      Object.keys(info.properties).forEach((propertie) => {
        if (propertie !== "CW") {
          const condition = yearsAntique + info.properties[propertie].trim();
          if (eval(condition)) {
            const findModalitie = modalities.find(
              (modalitie) => modalitie.modalityKey === propertie
            );
            findModalitie["recommended"] = true;
          }
        }
      });
    }
    setModalitie(modalities);
  };

  const compareButton = () => {
    setShowCompare(!showCompare);
    const element = document.getElementById('print');
    element.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
        <div id="print"></div>
          {!showCompare && modalitie && modalitie.length > 0 && (
            <div className="plans plans-vertical">
              <Modalities
                modalities={modalitie}
                showDetail={showDetail}
                onNext={(modalitie) => next(modalitie)}
                coverages={coverages}
              />
            </div>
          )}
          {!showCompare && modalitie && modalitie.length > 0 && (
            <div className="plans-btn__container">
              <Button
                className="plans-btn ant-btn-transparent"
                onClick={() => setShowDetail(!showDetail)}
                data-testid="Ver"
              >
                Ver {!showDetail ? "más" : "menos"}
              </Button>
              <Button
                className="plans-btn ant-btn-transparent"
                onClick={compareButton}
                data-testid="Comparar"
              >
                Comparar
              </Button>
            </div>
          )}
          {showCompare && (
            <>
              <div className="print">
                <div className="scroll-hand">
                  <em className="fas fa-hand-rock" />
                  <span>Desliza para ver más</span>
                </div>
                <div className="plans compare">
                  <div className="plans__item">
                    <img src={image} alt={subTitle}/>
                    <Button
                      className="ant-btn-outline ant-btn-size-xs c-2"
                      data-testid="btn-print"
                      onClick={async () => {
                        const doc = (
                          <Pdf
                            modalities={modalitie}
                            coverages={mandatories}
                            coveragesAdditionals={mandatoriesAdditionals}
                            subTitle={subTitle}
                          />
                        );
                        const asPdf = pdf([]);
                        asPdf.updateContainer(doc);
                        const blob = await asPdf.toBlob();
                        saveAs(blob, "coberturas.pdf");
                      }}
                    >
                      Imprimir
                    </Button>
                  </div>
                  {modalitie && modalitie.length > 0 && (
                    <Modalities
                      modalities={modalitie}
                      showDetail={showDetail}
                      onNext={(modalitie) => next(modalitie)}
                      coverages={[]}
                    />
                  )}
                </div>
                <div className="compare-coverages">
                  <ul className="compare-coverages__container">
                    {mandatories &&
                      mandatories.length &&
                      mandatories.map((mandatorie, index) => (
                        <li
                          className="compare-coverages__container-content"
                          key={index}
                        >
                          <div className="compare-coverages__container-content__item">
                            {mandatorie.description}
                            <Tooltip
                              title={mandatorie.tooltip}
                              placement="right"
                              overlayClassName="tooltip-plans"
                            >
                              <em className="fal fa-info-circle" />
                            </Tooltip>
                          </div>
                          {modalitie.map((modalitie) => (
                            <div className="compare-coverages__container-content__item">
                              {mandatorie.modalities[modalitie.modalityId]
                                ? mandatorie.modalities[modalitie.modalityId]
                                  .description
                                : "-"}
                            </div>
                          ))}
                        </li>
                      ))}
                  </ul>
                  <ul className="compare-coverages__container additional">
                    <div className="additional__title">
                      {subTitle}
                    </div>
                    {mandatoriesAdditionals &&
                      mandatoriesAdditionals.length &&
                      mandatoriesAdditionals.map((coverageAdd, index) => (
                        <li
                          className="compare-coverages__container-content"
                          key={index}
                        >
                          <div className="compare-coverages__container-content__item">
                            {coverageAdd.description}
                          </div>
                          {modalitie.map((modalitie) => (
                            <div className="compare-coverages__container-content__item">
                              {
                                coverageAdd.modalities[modalitie.modalityId]
                                  ? <img src={Check} alt="Imagen cobertura incluida" />
                                  : "-"
                              }
                            </div>
                          ))}
                        </li>
                      ))}
                  </ul>
                </div>
              </div>

              {message && message.length > 0 && (
                <div className="plans-alert">
                  <AlertInfo message={message} img={{url:imageColision,alt:'Imagen Colision'}} />
                </div>
              )}
              <div className="plans-btn__container">
                <Button
                  className="plans-btn ant-btn-transparent no-border"
                  onClick={() => setShowCompare(!showCompare)}
                  data-testid="Regresar"
                >
                  Regresar
                </Button>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
}
